// Responsive photo variants, derived by `npm run photos` (scripts/make-photos.sh):
//   <name>.jpg       1200 px long edge — DPR-3 phones (iPhone)
//   <name>-800.jpg    800 px long edge — DPR-2 phones, Lighthouse's Moto G
// The phone frame is 100vw on phones and 390 px on desktop, so `sizes` is
// the same for every full-width photo (heroes, plates, the detail overlay).
export const SIZES = '(max-width: 480px) 100vw, 390px';
export const srcSet = (p) => (p && p.endsWith('.jpg') ? `${p.replace(/\.jpg$/, '-800.jpg')} 800w, ${p} 1200w` : undefined);

// The filter scene's pinned hero. Shared so the build-time preload and the
// component can never drift apart.
export const PARAGON = '/illustrations/paragon-brewing.jpg';
